export const UPDATE_SYMBOLS_LIST = "UPDATE_SYMBOLS_LIST";